const hexify = (color) => (color ? (color.startsWith("#") ? color : `#${color}`) : null)

export default hexify
